/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PdpRespSimilarItemTileCarousel_user = {
    readonly serviceId: string | null;
    readonly " $fragmentRefs": FragmentRefs<"PdpRespSimilarItem_user">;
    readonly " $refType": "PdpRespSimilarItemTileCarousel_user";
};
export type PdpRespSimilarItemTileCarousel_user$data = PdpRespSimilarItemTileCarousel_user;
export type PdpRespSimilarItemTileCarousel_user$key = {
    readonly " $data"?: PdpRespSimilarItemTileCarousel_user$data;
    readonly " $fragmentRefs": FragmentRefs<"PdpRespSimilarItemTileCarousel_user">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespSimilarItemTileCarousel_user",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "serviceId",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespSimilarItem_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};
(node as any).hash = 'b9a3b17243d2a465019cbba29af6bebd';
export default node;
